import styled from "styled-components"

export const FooterWrapper = styled.div`
    padding: 80px 0 0 0;
    .main{
        h3{
            text-align: center;
            font-size: 1.4rem;
        }
        p{
            text-align: center;
        }
    }
    .list_service{
        display: flex;
        justify-content: space-between;
    }
    .title{
        display: flex;
        justify-content: center;
    }
    .item{
        margin: 0 10px;
    }
    .content{
        text-align: center;
        background-color: 
#f9f0ab ;
        padding: 10px;
    }
`

export const ScrollToTop = styled.div`
  z-index: 99999;
  position: fixed;
        bottom: 108px;
        right: 25px;
        width: 60px;
        height: 60px;
        border-radius: 50%;
        background-color: #ff6801;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        &:hover{
            background-color: #fd475a;
        }
        i{
            font-size: 1.4rem;
            font-weight: 500;
            color: #fff;
        }
`
